import "core-js/modules/es.array.concat.js";
import cssVars from './cssVars';
export var CSS_VARS = cssVars;
export var EVENT_TYPE = {
  /**
   * Triggered before context menu is open.
   */
  BEFOREOPEN: 'beforeopen',
  /**
   * Triggered when context menu is open.
   */
  OPEN: 'open',
  /**
   * Triggered when context menu is closed.
   */
  CLOSE: 'close',
  /**
   * Internal. Triggered when a menu entry is added.
   */
  ADD_MENU_ENTRY: 'add-menu-entry',
  /**
   * Internal.
   */
  CONTEXTMENU: 'contextmenu',
  /**
   * Internal.
   */
  HOVER: 'mouseover'
};
export var DEFAULT_OPTIONS = {
  width: 150,
  scrollAt: 4,
  eventType: EVENT_TYPE.CONTEXTMENU,
  defaultItems: true
};
export var DEFAULT_ITEMS = [{
  text: 'Zoom In',
  classname: "".concat(cssVars.zoomIn, " ").concat(cssVars.icon),
  callback: function callback(obj, map) {
    var view = map.getView();
    view.animate({
      zoom: +view.getZoom() + 1,
      duration: 700,
      center: obj.coordinate
    });
  }
}, {
  text: 'Zoom Out',
  classname: "".concat(cssVars.zoomOut, " ").concat(cssVars.icon),
  callback: function callback(obj, map) {
    var view = map.getView();
    view.animate({
      zoom: +view.getZoom() - 1,
      duration: 700,
      center: obj.coordinate
    });
  }
}];